import { render, staticRenderFns } from "./GameSelect.vue?vue&type=template&id=32aacc86&scoped=true"
import script from "./GameSelect.vue?vue&type=script&lang=js"
export * from "./GameSelect.vue?vue&type=script&lang=js"
import style0 from "./GameSelect.vue?vue&type=style&index=0&id=32aacc86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aacc86",
  null
  
)

export default component.exports